const constant = {
  error: {
    scheduleDateError: "Please select the Schedule Date",
    endOfTripError: "Please select the End of Trip Date",
    departureTimeRequired: "Please select departure time",
    arrivalTimeRequired: "Please select arrival time",
    dayOfWeekRequired: "Please select day(s) of the week",
    desiredChargedLevelRequired: "Please select your desired charge level",
    arrivalTimeMustBeGreaterThanDepartureTime:
      "Arrival Time must be greater than Departure Time",
    arrivalTimeAndDepartureTimeMustBeWithInSameDay:
      "Arrival Time and Departure time must be within same day if you are selecting recurring as an option",
  },
};

export default constant;
